/**
 * Fiskal Cloud Admin ELSTER Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractStatusEnumDTO } from './contract-status-enum-dto';


/**
 * Defines contract properties. Includes a period, when the contract was assigned and the number of contracted ERSes.
 */
export interface ElsterContractPropertiesLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber: string;
    /**
     * Month when the contract changed or ended. Note: This month is excluded (the value represents the first second of the month).
     */
    to?: string;
    status?: ContractStatusEnumDTO;
    /**
     * Customer name used for the contract.
     */
    customerName?: string;
}

export class ClsElsterContractPropertiesLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string = undefined;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber: string = undefined;
    /**
     * Month when the contract changed or ended. Note: This month is excluded (the value represents the first second of the month).
     */
    to?: string = undefined;
    status?: ContractStatusEnumDTO = undefined;
    /**
     * Customer name used for the contract.
     */
    customerName?: string = undefined;
}



